import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useNavigate } from "react-router-dom";
import { Box, Button, Stack } from "@mui/material";
import onDate from "../utils/Date";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import DeleteIcon from "@mui/icons-material/Delete";
import { useState } from "react";
import { useEffect } from "react";

const docStatus = {
  sended: "Enviado",
  viewed: "Visualizado",
  downloaded: "Baixado",
};

export default function TableDocuments(props) {
  const {
    isUserPage,
    documents,
    categories,
    handleDeleteDocument,
    handleDownload,
  } = props;
  const [documentsByCategory, setDocumentsByCategory] = useState([]);
  console.log(documentsByCategory);
  const navigate = useNavigate();
  const navigateTo = () => {
    navigate("/documents");
  };

  const zeroFill = (n) => {
    return ("0" + n).slice(-2);
  };
  const handleDate = (dateCreatedAt) => {
    const date = new Date(dateCreatedAt);
    const dateCreated =
      zeroFill(date.getUTCDate()) +
      "/" +
      zeroFill(date.getMonth() + 1) +
      "/" +
      date.getFullYear();
    return dateCreated;
  };

  useEffect(() => {
    if (categories && documents) {
      const data = documents.map((d) => {
        const category = categories.find((c) => c.id === d.category_id);

        return { ...d, category };
      });
      console.log(data);
      setDocumentsByCategory(data);
    }
  }, [categories, documents]);
  if (isUserPage) {
    return (
      <Box sx={{ overflow: "auto", mt: 2 }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell>Documento</TableCell>
              <TableCell align="center">Funcionário</TableCell>
              <TableCell align="center">Data de Envio</TableCell>
              <TableCell align="center">Status</TableCell>
              <TableCell align="center">Categoria</TableCell>
              <TableCell align="right">Opções</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {documentsByCategory &&
              documentsByCategory.length > 0 &&
              documentsByCategory.map((document) => (
                <TableRow key={document.id}>
                  <TableCell>{document.name}</TableCell>
                  <TableCell align="center">{document.creator.name}</TableCell>
                  <TableCell align="center">
                    {document.created_at && handleDate(document.created_at)}
                  </TableCell>
                  <TableCell align="center">
                    {docStatus[document.status]}
                  </TableCell>
                  <TableCell align="center">
                    {document.category
                      ? document.category.name
                      : "Sem categoria"}
                  </TableCell>
                  <TableCell align="right">
                    <Stack
                      direction="row"
                      spacing={2}
                      justifyContent="flex-end"
                    >
                      <Button
                        variant="contained"
                        endIcon={<CloudDownloadIcon />}
                        onClick={() =>
                          handleDownload(document.id, document.name)
                        }
                      >
                        Baixar
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={() => handleDeleteDocument(document.id)}
                        endIcon={<DeleteIcon />}
                      >
                        Excluir
                      </Button>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </Box>
    );
  }

  return (
    <Box sx={{ overflow: "auto", mt: 2, textAlign: "center" }}>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            <TableCell>Documento</TableCell>
            <TableCell align="center">Cliente</TableCell>
            <TableCell align="center">Funcionário</TableCell>
            <TableCell align="center">Data de Envio</TableCell>
            <TableCell align="right">Status do Documento</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {documents.length > 0 &&
            documents.map((document) => (
              <TableRow key={document.id}>
                <TableCell>{document.name}</TableCell>
                <TableCell align="center">{document.client.name}</TableCell>
                <TableCell align="center">{document.creator.name}</TableCell>
                <TableCell align="center">
                  {document.created_at
                    ? onDate(document.created_at)
                    : "00/00/0000"}
                </TableCell>
                <TableCell align="right">
                  {docStatus[document.status]}
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <Button color="primary" onClick={navigateTo} sx={{ mt: 3 }}>
        Veja todos Documentos
      </Button>
    </Box>
  );
}
